<template>
  <b-card>
    <b-form lg="3" @submit="onSubmit">
      <div v-if="editorType === 'title'">
        <b-row>
          <b-col>
            <b-form-group id="titleGroup">
              <h2 class="inputHeader">{{ $t('privatePage.expert_report_title_header') }}</h2>
              <b-form-input type="text" v-model="currentItem.title" required/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="descGroup">
              <h2 class="inputHeader">{{ $t('privatePage.expert_report_description_header') }}</h2>
              <b-form-textarea rows="10" v-model="currentItem.description"/>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div v-else-if="editorType === 'text'">
        <b-row>
          <b-col>
            <b-form-group id="textGroup">
              <h2 class="inputHeader">{{ $t('privatePage.expert_report_text_header') }}</h2>
              <b-form-textarea rows="10" v-model="currentItem.title" required/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="termsGroup">
              <h2 class="inputHeader">{{ $t('privatePage.expert_report_conditions_header') }}</h2>
              {{conditions}}
              <b-form-textarea rows="3" v-model="currentItem.condition"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="currentItem.id === undefined">
          <b-col lg="6">
            <b-form-group id="headerGroup">
              <h2 class="inputHeader">{{ $t('privatePage.expert_report_select_header') }}</h2>
              <b-form-select v-model="currentItem.belongsto" :options="allTitles"/>
            </b-form-group>
          </b-col>
          <b-col lg="6" v-if="false">
            <b-form-group id="headerGroup">
              <h2 class="inputHeader">{{ $t('privatePage.expert_report_select_subheader') }}</h2>
              <b-form-select v-model="currentItem.parent" :options="allCaptions"/>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div class="pull-right">
        <b-button type="submit" class="me-2" ref="submitButton">{{ $t('save') }}</b-button>
        <b-button type="button" class="me-2" ref="cancelButton" v-on:click="onCancel">{{ $t('cancel') }}</b-button>
        <b-button type="button" variant="danger" @click.stop="onDelete">{{ $t('delete') }}</b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
export default {
  name: 'expert-report-item-editor',
  data: function() {
    return {
      itemBeforeEdit: {}
    }
  },
  props: {
    isOpened: {},
    currentItem: {},
    allTitles: {},
    editorType: {},
    conditions: {}
  },
  methods: {
    onSubmit: function(evt) {
      evt.preventDefault()

      switch (this.editorType) {
        case 'title': {
          this.$emit('onTitleUpdated', this.currentItem)
          break
        }
        case 'text': {
          this.$emit('onTextUpdated', this.currentItem)
          break
        }
      }
    },
    onDelete: function(evt) {
      switch (this.editorType) {
        case 'title': {
          Object.assign(this.currentItem, this.itemBeforeEdit)
          this.$emit('titleDeleted', this.currentItem)
          break
        }
        case 'text': {
          Object.assign(this.currentItem, this.itemBeforeEdit)
          this.$emit('textDeleted', this.currentItem)
          break
        }
      }
    },
    onCancel: function(evt) {
      Object.assign(this.currentItem, this.itemBeforeEdit)
      this.$emit('formCancelled')
    }
  },
  watch: {
    isOpened: function() {
      if (this.isOpened === true) {
        this.itemBeforeEdit = Object.assign({}, this.currentItem)
      }
    }
  }
}
</script>
